import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Resolve image URL — handles both relative /api/files/* and absolute http(s) URLs
export const resolveImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:")) return src;
  return `${BACKEND_URL}${src}`;
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("divine_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const BRAND = {
  name: "Divine Interiors",
  owner: "Ratnnessh Shaah",
  ownerTitle: "Founder · Interior Designer & Vastu Consultant",
  tagline: "Interior Designer & Vastu Consultant",
  phone: "+91 9974372369",
  phoneRaw: "+919974372369",
  website: "www.shobhanirmiti.com",
  instagram: "divineinteriors.2369",
  instagramUrl: "https://instagram.com/divineinteriors.2369",
  email: "hello@shobhanirmiti.com",
  logo: "https://customer-assets.emergentagent.com/job_18d69392-8061-415a-8dde-169621a8fca3/artifacts/495rpq1c_IMG_1381.PNG",
  logoIcon: "https://customer-assets.emergentagent.com/job_18d69392-8061-415a-8dde-169621a8fca3/artifacts/w4bk9ybm_IMG_1382.PNG",
};

export const SERVICES = [
  { key: "Residential", title: "Residential Interior", desc: "Soulful homes designed around how you actually live." },
  { key: "Commercial", title: "Commercial Interior", desc: "Workspaces that elevate brand, energy and productivity." },
  { key: "Vastu", title: "Vastu Consultation", desc: "Align your space with ancient principles for lasting wellbeing." },
  { key: "Modular Kitchen", title: "Modular Kitchen", desc: "Functional, beautiful kitchens crafted to your rhythm." },
  { key: "Home Renovation", title: "Home Renovation", desc: "Renew tired interiors with thoughtful, lasting upgrades." },
];

export const TIME_SLOTS = [
  "10:00 AM", "11:00 AM", "12:00 PM",
  "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM", "06:00 PM",
];
